import { WppTypography } from '@wppopen/components-library-react'
import AiOutputTextBlock from '../AiOutputTextBlock/AiOutputTextBlock'
import { uuidv4 } from '@wppopen/components-library'
import { snakeCaseToSentenceCase } from 'utils'
import type { SanitisedProductData, SanitisedBrandData } from '../AiOutput.d'
import AiOutputStyles from '../AiOutput.module.scss'
import type { v5 } from '@contracts'
import { CategoriesDetailData } from '../../../../../../dist/libs/api-contracts/lib/generated/v5/data-contracts'

interface AiOutputContainerProps {
  outputData?: SanitisedProductData | SanitisedBrandData | v5.RetailersDetailData | CategoriesDetailData
}

export default function AiOutputContainer({ outputData }: AiOutputContainerProps) {
  return (
    <section data-testid="ai-output-container">
      {!outputData ? (
        <WppTypography type="s-body" className={AiOutputStyles.center} data-testid="error-message">
          Sorry, something went wrong, either the data is missing or the tab data is missing.
        </WppTypography>
      ) : (
        Object.entries(outputData).map(([title, dataValue]) => (
          <div key={uuidv4()} data-testid={`${title}-container`}>
            <WppTypography type="m-strong" data-testid={`${title}-title`}>
              {snakeCaseToSentenceCase(title)}
            </WppTypography>
            <br />
            {typeof dataValue === 'object' && dataValue !== null ? (
              // If it's an object, use AiOutputTextBlock
              Object.keys(dataValue)?.length ? (
                <AiOutputTextBlock outputData={dataValue} />
              ) : (
                <WppTypography type="s-body" tag="p" style={{ color: 'grey' }} data-testid="none-added-data">
                  None Added
                </WppTypography>
              )
            ) : (
              // If it's a primitive value (string, number, boolean), display it directly
              <WppTypography type="s-body" tag="p" data-testid={`${title}-value`}>
                {String(dataValue)}
              </WppTypography>
            )}
          </div>
        ))
      )}
    </section>
  )
}
